import {
  TOGGLE_NOTIFICATIONS_LIST_VIEW,
  LOGOUT_COMPLETE,
  FORM_START,
  FORM_DID_END,
  FORM_DID_DISMISS,
  OPEN_RESOURCE_DETAIL_PANEL,
  CLOSE_RESOURCE_DETAIL_PANEL,
  OPEN_RESOURCE_EDIT_MODAL,
  CLOSE_RESOURCE_EDIT_MODAL,
  SET_DETAIL_VIEW_CARD,
  REMOVE_DETAIL_VIEW_CARD,
} from '../../constants/actionTypes';

const initialState = {
  notificationsListOpen: false,
  formViewOpen: false,
  detailPanelOpen: false,
  resourceEditModalOpen: false,
};

export const activeViewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_NOTIFICATIONS_LIST_VIEW:
      return {
        ...state,
        notificationsListOpen: !state.notificationsListOpen,
      };

    case OPEN_RESOURCE_DETAIL_PANEL:
    case SET_DETAIL_VIEW_CARD:
      return {
        ...state,
        detailPanelOpen: true,
      };

    case CLOSE_RESOURCE_DETAIL_PANEL:
    case REMOVE_DETAIL_VIEW_CARD:
      return {
        ...state,
        detailPanelOpen: false,
      };

    case FORM_START:
      return {
        ...state,
        formViewOpen: true,
      };

    case FORM_DID_END:
    case FORM_DID_DISMISS:
      return {
        ...state,
        formViewOpen: false,
      };

    case OPEN_RESOURCE_EDIT_MODAL:
      return {
        ...state,
        resourceEditModalOpen: true,
      };

    case CLOSE_RESOURCE_EDIT_MODAL:
      return {
        ...state,
        resourceEditModalOpen: false,
      };

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

export default activeViewsReducer;
